import { Reducer } from 'redux';
import { OrdemCargaPageState, OrdemCargaPageTypes } from './types';

const INITIAL_STATE: OrdemCargaPageState = {
  data: [],
  error: false,
  loading: false,
  filter: undefined,
  sorter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<OrdemCargaPageState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OrdemCargaPageTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OrdemCargaPageTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case OrdemCargaPageTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
      case OrdemCargaPageTypes.FILTER_ORDEMCARGAPAGE:
        return {
          ...state,
          filter: action.payload.filter,
        }; 
      case OrdemCargaPageTypes.SORTER_ORDEMCARGAPAGE:
        return {
          ...state,
          sorter: action.payload.sorter,
      }; 
    case OrdemCargaPageTypes.CLEAN_ORDEMCARGAPAGE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
